import { httpsCallable } from "firebase/functions";
import { useFunctions } from "reactfire";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Spinner } from "react-bootstrap";

const FreightBookingByVin = ({ vin }) => {
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  const functions = useFunctions();
  const history = useHistory();

  const getBookingByVin = async (v) => {
    try {
      const searchOS = httpsCallable(
        functions,
        "searchOpenSearchFreightBooking"
      );
      return await searchOS({ idx: "freight_bookings", query: v })
        .then(async (result) => {
          setLoading(true);
          setBooking(null); // Reset booking before setting new data
          console.log("Got result from searchOS");
          // Read result of the Cloud Function.
          var sanitizedMessage = result.data;
          if (sanitizedMessage === false) {
            console.log("None");
          } else {
            if (sanitizedMessage.error?.length > 0) {
              console.log("Error: " + sanitizedMessage.error);
            } else {
              console.log(sanitizedMessage);
              const response = sanitizedMessage;
              // setQuerySearchResults(sanitizedMessage);
              for (var i = 0; i < response?.datarows?.length; i++) {
                const r = response?.datarows[i];
                let output = {};

                for (var j = 0; j < r.length; j++) {
                  const fieldName = response.schema[j]?.name;
                  output = { ...output, [fieldName]: r[j] };
                }
                output.estimatedDeliveryDate =
                  sanitizedMessage?.bookingDetails?.carrierData
                    ?.estimatedDeliveryDate || null;
                console.log("output", output);
                setBooking(output);
                setLoading(false);
                return output;
              }
            }
          }
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          return [];
        });
    } catch (error) {
      console.error("Error fetching booking:", error);
    }
  };

  useEffect(() => {
    if (vin.length === 17) {
      console.log("Fetching booking for VIN:", vin);
      getBookingByVin(vin);
    } else {
      console.log("Invalid VIN length:", vin);
      setBooking(null);
    }
  }, [vin]);

  if (loading) {
    return (
      <div>
        <Spinner size="sm" animation="border" />
      </div>
    );
  }

  if (booking === null) {
    return <div>No Freight Booking Info Found</div>;
  } else if (booking && booking?.estimatedDeliveryDate === null) {
    return (
      <div>
        Delivery date not available{" "}
        <span
          onClick={() =>
            window.open(`/freight-booking-list/${booking?.bookingId}`, "_blank")
          }
          style={{
            textDecoration: "underline",
            color: "blue",
            cursor: "pointer",
          }}
        >
          {" "}
          (Open booking in new tab)
        </span>
      </div>
    );
  } else {
    return (
      <span>
        Estimated Delivery Date: {booking && booking?.estimatedDeliveryDate}
        {" with "}
        {booking && booking?.carrier}{" "}
        <span
          onClick={() =>
            window.open(`/freight-booking-list/${booking?.bookingId}`, "_blank")
          }
          style={{
            textDecoration: "underline",
            color: "blue",
            cursor: "pointer",
          }}
        >
          {" "}
          (Open booking in new tab)
        </span>
      </span>
    );
  }
};

export default FreightBookingByVin;
